<template>
  <!-- Anagrafica dell'utente (profilo di cittadino e operatore): tre card
       .settings-card con la testa dentro (icona, titolo, Modifica). In sola
       lettura sfuma il contenuto, non la testa. Residenza e contatti
       affiancati in .settings-pair. Un solo b-form per le tre sezioni. -->
  <div class="anagrafica">
    <b-form @submit.prevent="onSubmit">
      <!-- Profilo -->
      <section class="shadowedCard p-4 settings-card mb-4">
        <div class="section-head mb-3">
          <b-icon icon="person" class="section-head__icon" aria-hidden="true"></b-icon>
          <h2 class="section-title mb-0 mr-auto">{{$t('AnagraficaComponent.profilo')}}</h2>
          <b-button
            v-if="!editIndexes[0]"
            type="button"
            variant="outline-secondary"
            size="sm"
            @click="setEditIndex(0, true)"
          >
            {{$t('AnagraficaComponent.modifica')}}
          </b-button>
        </div>
        <div
          class="d-flex flex-column flex-md-row h-100 align-items-md-stretch"
          :class="{ 'read-only-opacity': !editIndexes[0] }"
        >
          <div
            class="d-flex flex-column justify-content-center align-items-center justify-content-md-start text-center col-12 col-md-3 col-xl-3 mb-4 mb-md-0 p-3 p-md-0"
          >
            <b-avatar
              variant="white"
              :src="avatarPath"
              rounded
              :size="$root.isMobile ? '5rem' : '10rem'"
              class="mx-md-auto mb-md-2"
            >
            </b-avatar>
            <div class="mt-2 d-flex flex-column justify-content-around px-4">
              <b-button
                @click="
                  editIndexes[0] ? $refs.uploadComponentRef.click() : null
                "
                class="mb-2"
                variant="secondary"
              >
                {{$t('AnagraficaComponent.scegli_immagine')}}
              </b-button>
              <b-button
                v-if="avatarPath"
                @click="editIndexes[0] ? eliminaAvatarProfilo() : null"
                class=""
                variant="outline-danger mb-2"
              >
                {{$t('AnagraficaComponent.elimina')}}
              </b-button>
              <div class="d-none">
                <UploadComponent
                  dest="profilo"
                  class="w-100 mb-n2 pb-1"
                  @show-carica-button="handleFileSelection($event)"
                  v-on:upload-result="handleUpload($event)"
                  ref="uploadComponentRef"
                />
              </div>
              <b-button
                v-if="showCaricaButton"
                @click="callDoUploadOnUploadComponent"
                class="mb-md-3"
                variant="secondary"
              >
                {{$t('AnagraficaComponent.carica_immagine')}}
              </b-button>
            </div>
          </div>
          <b-row cols="1" cols-md="2" cols-xl="3">
            <b-col>
              <b-row>
                <b-form-group
                  :label="$t('AnagraficaComponent.titolo')"
                  label-for="title"
                  class="text-left col-auto campo-titolo p-0 pr-1"
                >
                  <b-form-input
                    v-capitalize-first
                    v-if="!editIndexes[0]"
                    class="my-3"
                    name="title"
                    type="text"
                    :placeholder="$t('AnagraficaComponent.titolo_placeholder')"
                    v-model="anagrafica.title"
                    :readonly="!editIndexes[0]"
                  ></b-form-input>
                  <b-form-select
                    v-capitalize-first-select
                    v-else
                    class="mb-3 mt-2 custom-select select-compact"
                    name="title"
                    v-model="anagrafica.title"
                    :options="titleOptions"
                  >
                  </b-form-select>
                </b-form-group>
                <b-form-group
                  :label="$t('AnagraficaComponent.nome')"
                  label-for="name"
                  class="text-left col campo-nome p-0"
                >
                  <b-form-input
                    v-capitalize-first
                    class="my-3"
                    name="name"
                    type="text"
                    :placeholder="$t('AnagraficaComponent.nome_placeholder')"
                    v-model="anagrafica.name"
                    :readonly="!editIndexes[0]"
                  ></b-form-input>
                </b-form-group>
              </b-row>
            </b-col>

            <b-col>
              <b-form-group
                :label="$t('AnagraficaComponent.cognome')"
                label-for="surname"
                class="text-left"
              >
                <b-form-input
                  v-capitalize-first
                  class="my-3"
                  name="surname"
                  type="text"
                  :placeholder="$t('AnagraficaComponent.cognome_placeholder')"
                  v-model="anagrafica.surname"
                  :readonly="!editIndexes[0]"
                ></b-form-input>
              </b-form-group>
            </b-col>

            <b-col>
              <b-form-group
                :label="$t('AnagraficaComponent.data_nascita')"
                label-for="birthday"
                class="text-left"
              >
                <b-form-input
                  v-capitalize-first
                  class="my-3"
                  name="birthday"
                  type="date"
                  v-model="anagrafica.birthday"
                  :state="anagrafica.birthday && validAge === false ? false : null"
                  :readonly="!editIndexes[0]"
                ></b-form-input>
                <b-form-invalid-feedback :state="anagrafica.birthday && validAge === false ? false : null">
                  L'età deve essere di almeno 14 anni
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>

            <b-col>
              <b-form-group
                :label="$t('AnagraficaComponent.genere')"
                label-for="gender"
                class="text-left d-flex flex-column justify-content-around"
              >
                <b-form-radio-group
                  v-model="anagrafica.gender"
                  name="gender-options"
                  class="d-flex mt-2"
                >
                  <b-form-radio value="maschile">{{$t('AnagraficaComponent.uomo')}}</b-form-radio>
                  <b-form-radio value="femminile">{{$t('AnagraficaComponent.donna')}}</b-form-radio>
                </b-form-radio-group>
              </b-form-group>
            </b-col>

            <b-col>
              <b-form-group
                :label="$t('AnagraficaComponent.codice_fiscale')"
                label-for="cf"
                class="text-left"
              >
                <b-form-input
                  class="my-3"
                  name="cf"
                  type="text"
                  :placeholder="$t('AnagraficaComponent.codice_fiscale_placeholder')"
                  maxlength="16"
                  minlength="16"
                  v-model="anagrafica.cf"
                  @input="anagrafica.cf = anagrafica.cf ? anagrafica.cf.toUpperCase() : anagrafica.cf"
                  :readonly="!editIndexes[0]"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                :label="$t('AnagraficaComponent.tessera_sanitaria')"
                label-for="ts_number"
                class="text-left"
              >
                <b-form-input
                  v-capitalize-first
                  class="my-3"
                  name="ts_number"
                  type="text"
                  :placeholder="$t('AnagraficaComponent.tessera_sanitaria_placeholder')"
                  v-model="anagrafica.ts_number"
                  maxlength="20"
                  minlength="20"
                  :readonly="!editIndexes[0]"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                :label="$t('AnagraficaComponent.nazione_nascita')"
                label-for="nazione_nascita"
                class="text-left"
              >
                <b-form-input
                  v-capitalize-first
                  v-if="!editIndexes[0]"
                  class="my-3 text-capitalize"
                  name="nazione_nascita"
                  type="text"
                  placeholder="..."
                  v-model="anagrafica.nazione_nascita"
                  readonly
                ></b-form-input>
                <b-form-select
                  v-capitalize-first-select
                  v-else
                  class="mb-3 mt-2 text-capitalize"
                  :options="nazioniOptions"
                  name="nazione_nascita"
                  v-model="anagrafica.nazione_nascita"
                  required
                >
                </b-form-select>
              </b-form-group>
            </b-col>
            <template v-if="user.type === 0">
              <b-col>
                <b-form-group
                  :label="$t('AnagraficaComponent.medico_base')"
                  label-for="medico_base"
                  class="text-left"
                >
                  <b-form-input
                    class="my-3"
                    name="medico_base"
                    type="text"
                    v-capitalize-first
                    :placeholder="$t('AnagraficaComponent.medico_base_placeholder')"
                    v-model="anagrafica.medico_base"
                    :readonly="!editIndexes[0]"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group
                  v-if="editIndexes[0]"
                  :label="$t('AnagraficaComponent.asl')"
                  label-for="denominazione_asl"
                  class="text-left"
                >
                  <b-form-select
                    v-capitalize-first-select
                    class="mb-3 mt-2 custom-select text-capitalize"
                    name="denominazione_asl"
                    v-model="anagrafica.denominazione_asl"
                    :disabled="!editIndexes[0]"
                  >
                    <b-form-select-option
                      class="text-capitalize"
                      v-for="aslOption in asl"
                      :key="aslOption"
                      :value="aslOption"
                      >{{ aslOption }}</b-form-select-option
                    >
                    <b-form-select-option :value="null"
                      >{{$t('AnagraficaComponent.scegli_asl')}}</b-form-select-option
                    >
                  </b-form-select>
                </b-form-group>
                <b-form-group
                  v-else
                  :label="$t('AnagraficaComponent.asl')"
                  label-for="denominazione_asl"
                  class="text-left"
                >
                  <b-form-input
                    v-capitalize-first
                    readonly
                    :placeholder="$t('AnagraficaComponent.asl_placeholder')"
                    class="my-3 text-capitalize"
                    name="denominazione_asl"
                    v-model="anagrafica.denominazione_asl"
                  >
                  </b-form-input>
                </b-form-group>
              </b-col>
            </template>
            <template v-else-if="user.type === 1">
              <b-col>
                <b-form-group
                  label="Ordine"
                  label-for="tipo_albo"
                  class="text-left"
                >
                  <b-form-input
                    v-capitalize-first
                    v-if="!editIndexes[0]"
                    class="my-3 text-capitalize"
                    name="tipo_albo"
                    type="text"
                    placeholder="Albo ordine..."
                    v-model="anagrafica.tipo_albo"
                    :readonly="!editIndexes[0]"
                  ></b-form-input>
                  <b-form-select
                    v-capitalize-first-select
                    v-else
                    class="mb-3 mt-2 custom-select text-capitalize"
                    name="tipo_albo"
                    v-model="anagrafica.tipo_albo"
                    :options="tipoAlboOptions"
                  >
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col v-if="!editIndexes[0]">
                <b-form-group
                  :label="$t('AnagraficaComponent.id_albo')"
                  label-for="id_albo"
                  class="text-left"
                >
                  <b-form-input
                    class="my-3 text-capitalize"
                    name="id_albo"
                    type="text"
                    :placeholder="$t('AnagraficaComponent.id_albo_placeholder')"
                    v-model="anagrafica.id_albo"
                    readonly
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col v-else>
                <b-row>
                  <b-form-group
                    :label="$t('AnagraficaComponent.albo_province')"
                    label-for="provincia_albo"
                    class="text-left col-4 col-xl-3 p-0 pr-1"
                  >
                    <b-form-select
                      class="mb-3 mt-2 custom-select text-uppercase"
                      name="provincia_albo"
                      v-model="provinciaAlbo"
                      :options="provinceAlboOptions"
                    >
                    </b-form-select>
                  </b-form-group>
                  <b-form-group
                    :label="$t('AnagraficaComponent.albo_number')"
                    label-for="numero_albo"
                    class="text-left col p-0"
                  >
                    <b-form-input
                      class="my-3"
                      name="numero_albo"
                      type="text"
                      :placeholder="$t('AnagraficaComponent.albo_number_placeholder')"
                      v-model="idAlbo"
                    ></b-form-input>
                  </b-form-group>
                </b-row>
              </b-col>
              <b-col>
                <b-form-group
                  label="Specializzazione"
                  label-for="specializzazione"
                  class="text-left"
                >
                  <b-form-input
                    v-capitalize-first
                    class="my-3"
                    name="specializzazione"
                    type="text"
                    placeholder="Specializzazione medica..."
                    v-model="anagrafica.specializzazione"
                    :readonly="!editIndexes[0]"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </template>
          </b-row>
        </div>
        <div v-if="editIndexes[0]" class="form-actions form-actions--end">
          <b-button
            type="button"
            variant="outline-secondary"
            size="sm"
            @click.prevent="handleAnnulla"
            >{{$t('AnagraficaComponent.annulla')}}</b-button
          >
          <b-button
            type="submit"
            variant="secondary"
            size="sm"
            :disabled="!enableBtn"
            >{{$t('AnagraficaComponent.salva')}}
          </b-button>
        </div>
      </section>

      <div class="settings-pair mb-4">
        <!-- Residenza -->
        <section class="shadowedCard p-4 settings-card">
          <div class="section-head mb-3">
            <b-icon icon="geo" class="section-head__icon" aria-hidden="true"></b-icon>
            <h2 class="section-title mb-0 mr-auto">{{$t('AnagraficaComponent.residenza')}}</h2>
            <b-button
              v-if="!editIndexes[1]"
              type="button"
              variant="outline-secondary"
              size="sm"
              @click="setEditIndex(1, true)"
            >
              {{$t('AnagraficaComponent.modifica')}}
            </b-button>
          </div>
          <b-row
            cols="1"
            cols-md="2"
            cols-xl="3"
            :class="{ 'read-only-opacity': !editIndexes[1] }"
          >
            <template v-if="!editIndexes[1]">
              <b-col>
                <b-form-group
                  :label="$t('AnagraficaComponent.regione')"
                  label-for="regione"
                  class="text-left"
                >
                  <b-form-input
                    v-capitalize-first
                    class="my-3 text-capitalize"
                    name="regione"
                    type="text"
                    :placeholder="$t('AnagraficaComponent.regione_placeholder')"
                    v-model="anagrafica.regione"
                    readonly
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group
                  :label="$t('AnagraficaComponent.provincia')"
                  label-for="provincia"
                  class="text-left"
                >
                  <b-form-input
                    v-capitalize-first
                    class="my-3 text-capitalize"
                    name="provincia"
                    type="text"
                    :placeholder="$t('AnagraficaComponent.provincia_placeholder')"
                    v-model="anagrafica.provincia"
                    readonly
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group
                  :label="$t('AnagraficaComponent.comune')"
                  label-for="comune"
                  class="text-left"
                >
                  <b-form-input
                    v-capitalize-first
                    class="my-3 text-capitalize"
                    name="comune"
                    type="text"
                    :placeholder="$t('AnagraficaComponent.comune_placeholder')"
                    v-model="anagrafica.comune"
                    readonly
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </template>
            <template v-else>
              <b-col>
                <b-form-group
                  :label="$t('AnagraficaComponent.regione')"
                  label-for="regione"
                  class="text-left"
                >
                  <b-form-select
                    v-capitalize-first-select
                    class="my-3 custom-select text-capitalize"
                    :options="regioni"
                    name="regione"
                    v-model="selected.regione"
                    @change="getProvince(selected)"
                    :disabled="!editIndexes[1]"
                  >
                    <b-form-select-option :value="null"
                      >{{$t('AnagraficaComponent.seleziona_regione')}}</b-form-select-option
                    >
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group
                 :label="$t('AnagraficaComponent.provincia')"
                  label-for="provincia"
                  class="text-left"
                >
                  <b-form-select
                    v-capitalize-first-select
                    class="my-3 text-capitalize"
                    :options="province"
                    name="provincia"
                    v-model="selected.provincia"
                    @change="getComuni(selected)"
                    :disabled="!editIndexes[1]"
                  >
                    <b-form-select-option :value="null"
                      >{{$t('AnagraficaComponent.seleziona_provincia')}}</b-form-select-option
                    >
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group
                  :label="$t('AnagraficaComponent.comune')"
                  label-for="comune"
                  class="text-left"
                >
                  <b-form-select
                    v-capitalize-first-select
                    class="my-3 text-capitalize"
                    name="comune"
                    v-model="selected.comune"
                    :key="
                      comuni && comuni.length
                        ? comuni[0].comune + comuni.length
                        : null
                    "
                    :disabled="!editIndexes[1]"
                  >
                    <b-form-select-option
                      v-for="(com, ind) in comuni"
                      :key="ind"
                      :value="com"
                      @change="setDomicilioData"
                      :selected="findComune(com)"
                      >{{ com.comune }}</b-form-select-option
                    >
                    <b-form-select-option :value="null"
                      >{{$t('AnagraficaComponent.seleziona_comune')}}</b-form-select-option
                    >
                  </b-form-select>
                </b-form-group>
              </b-col>
            </template>
            <b-col>
              <b-form-group
                :label="$t('AnagraficaComponent.indirizzo')"
                label-for="address"
                class="text-left"
              >
                <b-form-input
                  v-capitalize-first
                  class="my-3 text-capitalize"
                  name="address"
                  required
                  type="text"
                  :placeholder="$t('AnagraficaComponent.indirizzo_placeholder')"
                  v-model="anagrafica.address"
                  :readonly="!editIndexes[1]"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group :label="$t('AnagraficaComponent.cap')" label-for="cap" class="text-left">
                <b-form-input
                  v-capitalize-first
                  class="my-3"
                  name="cap"
                  type="text"
                  required
                 :placeholder="$t('AnagraficaComponent.cap_placeholder')"
                  v-model="anagrafica.cap"
                  minlength="5"
                  maxlength="5"
                  :readonly="!editIndexes[1]"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <div v-if="editIndexes[1]" class="form-actions form-actions--end">
            <b-button
              type="button"
              variant="outline-secondary"
              size="sm"
              @click.prevent="handleAnnulla"
              >{{$t('AnagraficaComponent.annulla')}}</b-button
            >
            <b-button
              type="submit"
              variant="secondary"
              size="sm"
              :disabled="!enableBtn"
              >{{$t('AnagraficaComponent.salva')}}
            </b-button>
          </div>
        </section>

        <!-- Contatti -->
        <section class="shadowedCard p-4 settings-card">
          <div class="section-head mb-3">
            <b-icon icon="telephone" class="section-head__icon" aria-hidden="true"></b-icon>
            <h2 class="section-title mb-0 mr-auto">{{$t('AnagraficaComponent.contatti')}}</h2>
            <b-button
              v-if="!editIndexes[2]"
              type="button"
              variant="outline-secondary"
              size="sm"
              @click="setEditIndex(2, true)"
            >
              {{$t('AnagraficaComponent.modifica')}}
            </b-button>
          </div>
          <b-row
            cols="1"
            :class="{ 'read-only-opacity': !editIndexes[2] }"
          >
            <b-col>
              <b-form-group
               :label="$t('AnagraficaComponent.telefono')"
                label-for="tel_number"
                class="text-left"
              >
                <b-input-group>
                  <b-input-group-prepend>
                    <b-form-input
                      v-if="!editIndexes[2]"
                      class="my-3 text-center"
                      name="prefix_readonly"
                      type="text"
                      v-model="anagrafica.prefix"
                      readonly
                      style="max-width: 80px;"
                    ></b-form-input>
                    <b-form-select
                      v-else
                      class="my-3 text-capitalize prefix-select"
                      name="prefix"
                      v-model="anagrafica.prefix"
                      required
                    >
                      <b-form-select-option
                        v-for="(prefisso, index) in prefissi"
                        :value="prefisso.prefisso"
                        :key="`${prefisso.prefisso}-${index}`"
                        >{{ prefisso.flag }}
                        {{ prefisso.prefisso }}</b-form-select-option
                      >
                    </b-form-select>
                  </b-input-group-prepend>
                  <b-form-input
                    v-capitalize-first
                    required
                    class="my-3"
                    name="tel_number"
                    type="text"
                    :placeholder="$t('AnagraficaComponent.telefono_placeholder')"
                    v-model="anagrafica.tel_number"
                    minlength="9"
                    maxlength="15"
                    :readonly="!editIndexes[2]"
                    :state="
                      editIndexes[2] && anagrafica.tel_number
                        ? validNumber
                        : null
                    "
                    @input="onPhoneInput"
                  ></b-form-input>
                </b-input-group>
                <b-form-invalid-feedback v-if="editIndexes[2] && anagrafica.tel_number && !validNumber">
                  <span v-if="anagrafica.tel_number && anagrafica.tel_number.length > 15">
                    Il numero di telefono non può superare 15 cifre.
                  </span>
                  <span v-else-if="anagrafica.tel_number && !/^\d+$/.test(anagrafica.tel_number)">
                    Il numero di telefono deve contenere solo cifre.
                  </span>
                  <span v-else-if="anagrafica.tel_number && anagrafica.tel_number.length < 9">
                    Il numero di telefono deve contenere almeno 9 cifre.
                  </span>
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <template v-if="user.type === 0">
              <b-col>
                <b-form-group
                  :label="$t('AnagraficaComponent.telefono_domicilio')"
                  label-for="home_number"
                  class="text-left"
                >
                  <b-form-input
                    v-capitalize-first
                    class="my-3"
                    name="tel_number"
                    type="text"
                   :placeholder="$t('AnagraficaComponent.telefono_domicilio_placeholder')"
                    v-model="anagrafica.home_number"
                    minlength="9"
                    :readonly="!editIndexes[2]"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group
                 :label="$t('AnagraficaComponent.telefono_riserva')"
                  label-for="tel_number_secondary"
                  class="text-left my-3"
                >
                  <b-input-group>
                    <b-input-group-prepend>
                      <b-form-input
                        v-if="!editIndexes[2]"
                        class="my-3 text-center"
                        name="prefix_secondary_readonly"
                        type="text"
                        v-model="anagrafica.prefix_secondary"
                        readonly
                        style="max-width: 80px;"
                      ></b-form-input>
                      <b-form-select
                        v-else
                        class="my-3 text-capitalize prefix-select"
                        name="prefix_secondary"
                        v-model="anagrafica.prefix_secondary"
                      >
                        <b-form-select-option
                          v-for="(prefisso, index) in prefissi"
                          :value="prefisso.prefisso"
                          :key="`${prefisso.prefisso}-secondary-${index}`"
                          >{{ prefisso.flag }}
                          {{ prefisso.prefisso }}</b-form-select-option
                        >
                      </b-form-select>
                    </b-input-group-prepend>
                    <b-form-input
                      v-capitalize-first
                      class="my-3"
                      name="tel_number"
                      type="text"
                      :placeholder="$t('AnagraficaComponent.telefono_riserva_placeholder')"
                      v-model="anagrafica.tel_number_secondary"
                      minlength="9"
                      :readonly="!editIndexes[2]"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </template>
          </b-row>
          <div v-if="editIndexes[2]" class="form-actions form-actions--end">
            <b-button
              type="button"
              variant="outline-secondary"
              size="sm"
              @click.prevent="handleAnnulla"
              >{{$t('AnagraficaComponent.annulla')}}</b-button
            >
            <b-button
              type="submit"
              variant="secondary"
              size="sm"
              :disabled="!enableBtn"
              >{{$t('AnagraficaComponent.salva')}}
            </b-button>
          </div>
          <!-- Numero non ancora verificato: si torna alla verifica da qui -->
          <button
            v-if="!this.user.number_verified_at"
            type="button"
            class="back-link mt-3 mb-0"
            @click="$router.push({ name: 'Home' })"
          >
            <b-icon icon="arrow-left" aria-hidden="true"></b-icon>
            {{$t('AnagraficaComponent.torna_verifica')}}
          </button>
        </section>
      </div>
    </b-form>
    <b-modal
      id="delete-propic-confirm"
      size="lg"
      centered
      :title="$t('AnagraficaComponent.conferma_eliminazione')"
      button-size="sm"
      :cancel-title="$t('AnagraficaComponent.annulla')"
      cancel-variant="popup-button mr-2"
      :ok-title="$t('AnagraficaComponent.conferma')"
      ok-variant="popup-button"
      footer-class="border-0"
      @ok="deleteUserPropic"
      @cancel="$bvModal.hide('delete-propic-confirm')"
    >
      {{$t('AnagraficaComponent.domanda_eliminazione_immagine')}}
    </b-modal>
  </div>
</template>

<script>
import Vue from "vue";
import { cittadinoService } from "@/_services";
import * as moment from "moment/moment";
import UploadComponent from "@/app/common/components/utilities/UploadComponent.vue";
import { mapState, mapActions } from "vuex";
import { utilityService, userService, billingService } from "@/_services";
import { PREFIX_PAESI } from "@/_utils/constants.js";

export default {
  name: "AnagraficaComponent",
  computed: {
 titleOptions() {
    return [
      { value: 'Sig.',      text: this.$t('AnagraficaComponent.title_sig')   },
      { value: 'Sig.ra',    text: this.$t('AnagraficaComponent.title_sigra') },
      { value: 'Dott.',     text: this.$t('AnagraficaComponent.title_dott')  },
      { value: 'Dott.ssa',  text: this.$t('AnagraficaComponent.title_dottssa') }
    ];
  },
    tipoAlboOptions() {
      return [
        { value: null, text: this.$t('AnagraficaComponent.seleziona_tipo_albo') },
        { value: 'Medici', text: this.$t('AnagraficaComponent.tipo_medici') },
        { value: 'Dentisti', text: this.$t('AnagraficaComponent.tipo_dentisti') },
        { value: 'Farmacisti', text: this.$t('AnagraficaComponent.tipo_farmacisti') },
        { value: 'Infermieri', text: this.$t('AnagraficaComponent.tipo_infermieri') },
        { value: 'Biologi', text: this.$t('AnagraficaComponent.tipo_biologi') }
      ];
    },
    validNumber() {
      // Accetta solo cifre, lunghezza tra 9 e 15
      return /^\d{9,15}$/.test(this.anagrafica.tel_number || "");
    },
    provinceAlboOptions() {
      return [
        { value: null, text: this.$t('AnagraficaComponent.seleziona_provincia_albo') },
        ...this.provinceAlboList.map((p) => ({ value: p, text: p })),
      ];
    },
    provinceAlboList() {
      if (!this.provinceAlbo || !this.provinceAlbo.length) {
        return [];
      }
      return this.provinceAlbo
        .map((p) => {
          if (typeof p === 'string') return p.toUpperCase();
          if (p.sigla_provincia) return p.sigla_provincia.toUpperCase();
          if (p.provincia) return p.provincia.toUpperCase();
          return '';
        })
        .filter((p) => p.length > 0)
        .sort();
    },
    alboFieldsComplete() {
      return !this.idAlbo || !!this.provinciaAlbo;
    },
    validAge() {
      if (!this.anagrafica.birthday) {
        return null;
      }
      const birthDate = moment(this.anagrafica.birthday);
      const today = moment();
      const age = today.diff(birthDate, 'years');
      return age >= 14;
    },
    nazioniOptions() {
      if (this.nazioni && this.nazioni.length > 0) {
        return [
          { value: null, text: "Seleziona Nazione" },
          { value: "italia", text: "Italia" },
        ].concat(
          this.nazioni.map((nazione) => {
            return {
              value: nazione.nazione,
              text: nazione.nazione
                .toLowerCase()
                .split(" ")
                .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                .join(" "),
            };
          })
        );
      } else
        return [
          {
            value: null,
            text: "Seleziona Nazione",
          },
        ];
    },
    ...mapState("utente", ["status", "user"]),
    ...mapState("utility", [
      "searching",
      "comuni",
      "province",
      "regioni",
      "asl",
    ]),
  },
  components: {
    UploadComponent,
  },
  data() {
    return {
      editIndexes: [false, false, false],
      avatarPath: null,
      showCaricaButton: false,
      selected: {
        regione: null,
        provincia: null,
        comune: null,
      },
      anagrafica: {
        regione: null,
        provincia: null,
        comune: null,
        cap: null,
        address: null,
        name: null,
        surname: null,
        cf: null,
        gender: null,
        birthday: null,
        ts_number: null,
        prefix: "+39",
        tel_number: null,
        home_number: null,
        tel_number_secondary: null,
        prefix_secondary: "+39",
        medico_base: null,
        denominazione_asl: null,
        title: null,
        id_albo: null,
        tipo_albo: null,
        specializzazione: null,
        nazione_nascita: null,
      },
      provinciaAlbo: null,
      idAlbo: null,
      provinceAlbo: [],
      nazioni: [],
      enableBtn: false,
      isPost: true,
      selectingImage: false,
      prefissi: PREFIX_PAESI,
    };
  },
  methods: {
    ...mapActions("utility", [
      "getComuni",
      "getProvince",
      "getRegioni",
      "getAsl",
    ]),
    ...mapActions("utente", ["setAnagrafica", "me"]),
    loadProvinceAlbo() {
      billingService
        .getProvinces({ with_sigla: 1 })
        .then((response) => {
          const data = response.data.data || response.data || [];
          this.provinceAlbo = Array.isArray(data) ? data : [];
        })
        .catch(() => {
          this.provinceAlbo = [];
        });
    },
    ...mapActions({
      clearAlert: "alert/clear",
      errorAlert: "alert/error",
      successAlert: "alert/success",
      infoAlert: "alert/info",
    }),
    setEditIndex(index, value) {
      this.editIndexes.forEach((el, i) => {
        Vue.set(this.editIndexes, i, false);
      });
      Vue.set(this.editIndexes, index, value);
    },
    setDomicilioData() {
      if (this.selected.comune) {
        this.anagrafica.comune = this.selected.comune.comune;
        this.anagrafica.provincia = this.selected.comune.provincia;
        this.anagrafica.regione = this.selected.comune.regione;
      }
    },
    callDoUploadOnUploadComponent() {
      this.showCaricaButton = false;
      this.$refs.uploadComponentRef.doUpload();
    },
    deleteUserPropic() {
      var self = this;
      cittadinoService
        .deleteUserPropic()
        .then(function (res) {
          self.successAlert(self.$t('AnagraficaComponent.immagine_eliminata_successo'))
          self.avatarPath = null;
          self.me();
        })
        .catch(function (err) {
          console.log(err);
          self.errorAlert(self.$t('AnagraficaComponent.errore_eliminazione'))
        });
    },
    handleUpload(data) {
      const self = this;
      this.avatarPath = data.full_path;
      cittadinoService
        .attachUploadedResourceToUser(data.hashid)
        .then(function (res) {
          self.selectingImage = false;
          self.successAlert(self.$t('AnagraficaComponent.immagine_caricata_successo'))
          self.me();
        })
        .catch(function (err) {
          console.log(err);
          self.errorAlert(self.$t('AnagraficaComponent.errore_caricamento'))
        });
    },
    onSubmit() {
      // Controllo età minima
      if (this.anagrafica.birthday && this.validAge === false) {
        this.errorAlert("L'età deve essere di almeno 14 anni");
        return false;
      }
      
      if (this.anagrafica.tel_number && !this.validNumber) {
        this.errorAlert(this.$t('AnagraficaComponent.telefono_non_valido'))
        return false;
      }
      if (this.user.type === 1 && !this.alboFieldsComplete) {
        this.errorAlert(this.$t('AnagraficaComponent.albo_incompleto'))
        return false;
      }
      if (this.user.type === 1 && this.provinciaAlbo && this.idAlbo) {
        this.anagrafica.id_albo = (this.provinciaAlbo || '') + (this.idAlbo || '');
      } else if (this.user.type === 1) {
        this.anagrafica.id_albo = null;
      }
      // Se il telefono secondario non è impostato, imposta il prefisso secondario a null
      if (!this.anagrafica.tel_number_secondary) {
        this.anagrafica.prefix_secondary = null;
      }
      this.setAnagrafica({ form: this.anagrafica, isPost: this.isPost }).then(
        (res) => {
          window.scrollTo(0, 0);
          this.editIndexes = [false, false, false];
        }
      );
    },
    setupPrevs() {
      if (this.user.anagrafica.regione) {
        this.selected.regione = this.user.anagrafica.regione;
        this.getProvince(this.selected);
      }
      if (this.user.anagrafica.provincia) {
        this.selected.provincia = this.user.anagrafica.provincia;
        this.getComuni(this.selected);
      }
    },
    findComune(comune) {
      if (this.user.anagrafica && this.user.anagrafica.comune) {
        if (comune.comune === this.user.anagrafica.comune) {
          this.selected.comune = comune;
          return true;
        }
      }
      return false;
    },
    handleAnnulla() {
      this.editIndexes.forEach((el, index) => {
        Vue.set(this.editIndexes, index, false);
      });
      if (this.isPost) {
        $router.go(-1);
      }
      this.me();
    },
    handleFileSelection(file) {
      this.showCaricaButton = true;
      this.selectingImage = true;
      this.avatarPath = URL.createObjectURL(file);
    },
    eliminaAvatarProfilo() {
      if (this.selectingImage) {
        this.avatarPath = null;
        this.showCaricaButton = false;
        return;
      }
      this.$bvModal.show("delete-propic-confirm");
    },
    getNazioni() {
      var self = this;
      utilityService
        .nazioni()
        .then((res) => {
          self.nazioni = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    parseIdAlbo(idAlbo) {
      if (idAlbo) {
        const match = idAlbo.match(/^([A-Za-z]{2})(.*)$/);
        if (match) {
          this.provinciaAlbo = match[1].toUpperCase();
          this.idAlbo = match[2];
        } else {
          this.provinciaAlbo = null;
          this.idAlbo = idAlbo;
        }
      } else {
        this.provinciaAlbo = null;
        this.idAlbo = null;
      }
    },
    onPhoneInput() {
      // Rimuove caratteri non numerici in tempo reale
      this.anagrafica.tel_number = (this.anagrafica.tel_number || "")
        .replace(/\D/g, "")
        .slice(0, 15);
    },
  },
  watch: {
    anagrafica: {
      handler(prev, post) {
        this.enableBtn = true;
      },
      deep: true,
    },
    // provinciaAlbo() {
    //   this.enableBtn = true;
    // },
    // idAlbo() {
    //   this.enableBtn = true;
    // },
    selected: {
      handler(val) {
        if (val.comune !== null) {
          this.anagrafica.comune = this.selected.comune.comune;
          this.anagrafica.provincia = this.selected.comune.provincia;
          this.anagrafica.regione = this.selected.comune.regione;
        }
      },
      deep: true,
    },
    user: {
      handler(newUser) {
        if (newUser && newUser.anagrafica) {
          this.anagrafica = newUser.anagrafica;
          this.parseIdAlbo(this.anagrafica.id_albo);
          // Re-inizializza i prefissi se necessario
          if (!this.anagrafica.prefix) {
            this.anagrafica.prefix = "+39";
          }
          if (!this.anagrafica.prefix_secondary) {
            this.anagrafica.prefix_secondary = "+39";
          }
          this.setupPrevs();
        }
      },
      deep: true,
    },
  },
  created() {
    this.me();
    this.getRegioni();
    this.getNazioni();
    this.getAsl({ denominazione: true });
    this.loadProvinceAlbo();
    if (this.user.anagrafica !== null) {
      if (this.user.profile_pic) {
        this.avatarPath = this.user.profile_pic;
      }
      this.isPost = false;
      this.editIndexes = [false, false, false];
      this.anagrafica = this.user.anagrafica;
      this.parseIdAlbo(this.anagrafica.id_albo);
      // Se il prefisso è null o vuoto, imposta il default a +39
      if (!this.anagrafica.prefix) {
        this.anagrafica.prefix = "+39";
      }
      if (!this.anagrafica.prefix_secondary) {
        this.anagrafica.prefix_secondary = "+39";
      }
      this.enableBtn = false;
      this.setupPrevs();
    }
    // Se l'anagrafica è nuova, assicura i prefissi
    if (!this.anagrafica.prefix) {
      this.anagrafica.prefix = "+39";
    }
    if (!this.anagrafica.prefix_secondary) {
      this.anagrafica.prefix_secondary = "+39";
    }
  },
  mounted() {
    if (this.user.anagrafica !== null) {
      this.setupPrevs();
    }
  },
};
</script>
<style lang="scss" scoped>
.prefix-select {
  min-width: 120px !important;
  max-width: 120px !important;
}
// Titolo a larghezza fissa, che contiene «Dott.ssa» anche con il chevron del
// menu; il nome prende il resto e, sotto i 7rem, va a capo sotto il titolo
// invece di schiacciarlo (colonna stretta della card a 768px).
.campo-titolo {
  flex: 0 0 7.5rem;
  max-width: 7.5rem;
}
.campo-nome {
  min-width: 7rem;
}
</style>
